import { lazyNamed } from 'src/utils/lazyNamed';

const UserDetails = {
  Layout: lazyNamed(() => import('./components/Layout'), 'Layout'),
  AdministratingCompanies: lazyNamed(() => import('./containers/AdministratingCompanies'), 'AdministratingCompanies'),
};

export default UserDetails;
